<template>
    <div class="flex flex-col">
        <div class="-my-2 sm:-mx-6 lg:-mx-6">
            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div class="shadow border-b border-gray-200 sm:rounded-lg">
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                        <tr>
                            <th v-if="moveable" class="px-6 py-3 bg-gray-50 w-10">
                                &nbsp;
                            </th>
                            <th v-for="(column, name) in columns" scope="col" class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                <a v-if="column.sortable" @click.prevent="handleSort(column.sortBy)" href="#" class="flex flex-row items-center">
                                    {{ column.label || name.replaceAll('_', ' ') }}
                                    <svg-vue :icon=" desc ? 'arrow-up' : 'arrow-down'" class="h-4 w-4 fill-current"></svg-vue>
                                </a>
                                <template v-else> {{ column.label || name.replaceAll('_', ' ') }} </template>
                            </th>
                            <th scope="col" class="w-10 px-6 py-3 bg-gray-50">
                                <span class="sr-only">Action(s)</span>
                            </th>
                        </tr>
                        </thead>
                            <Draggable
                                tag="tbody"
                                handle=".input-handle"
                                v-model="mutableItems"
                                @end="handleDragEnd"
                            >
                                <tr v-for="(item, index) in items" :class="index%2 ? 'bg-gray-50' : 'bg-white'" :key="item.id ? item.id : index">
                                    <td v-if="moveable">
                                        <span class="input-handle rounded-t cursor-move flex flex-row justify-center items-center py-2 flex-1">
                                            <svg-vue icon="draggabledots" class="h-6 w-6 fill-current text-cyan-600"></svg-vue>
                                        </span>
                                    </td>
                                    <td v-for="(properties, name) in columns" class="px-6 py-4 text-sm text-gray-500">
                                        <div v-html="toHumanizedValue(properties, name.split('.').reduce( (o, k) => o && o[k], item))"></div>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                        <slot name="actions" :item="item"></slot>
                                        <a v-if="editable" href="/edit" class="text-indigo-600 hover:text-indigo-900 px-2" @click.prevent="handleEditItem(item)">Edit</a>
                                        <a v-if="manageable" href="/manage" class="text-indigo-600 hover:text-indigo-900 px-2" @click.prevent="handleManageItem(item)">Manage</a>
                                        <a v-if="deletable" href="/delete" class="text-red-600 hover:text-red-900 px-2" @click.prevent="handleDeleteItem(item)">Delete</a>
                                    </td>
                                </tr>
                            </Draggable>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {VueDraggableNext} from 'vue-draggable-next'

    export default {
        props: {
            columns: Object,
            items: [Array, Object],
            deletable: Boolean,
            editable: Boolean,
            manageable: Boolean,
            moveable: Boolean,
            desc: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                mutableItems: this.items
            }
        },
        computed: {
            locale() {
                return this.$store.state.config.locale;
            },
        },
        methods: {
            handleDeleteItem(item) {
                this.$emit('deleteItem', item);
            },
            handleEditItem(item) {
                this.$emit('editItem', item);
            },
            handleManageItem(item) {
                this.$emit('manageItem', item);
            },
            handleDragEnd() {
                this.$emit('dragEnd', this.items);
            },
            toHumanizedValue(properties, value) {
                // apply filter
                if(typeof properties.filter === 'string') {
                    if(properties.filter && this[properties.filter]) return this[properties.filter](value);
                }else if (typeof properties.filter === 'object') {
                    let filterName = Object.entries(properties.filter)[0][0];
                    let filterParams = Object.entries(properties.filter)[0][1];

                    if(filterName && this[filterName]) return this[filterName](value, filterParams);
                }

                return value;
            },
            toIsoDate(value) {
                if(value) {
                    return new Intl.DateTimeFormat('fr', {day: "2-digit", month: "2-digit", year: "numeric"}).format(new Date(value)).replaceAll('/', '-');
                }
            },
            truncate_words(value) {
                if(value) {
                    let truncated_value = value.replace(/^(.{100}[^\s]*).*/, "$1");

                    if(value !== truncated_value) {
                        return truncated_value + '...';
                    }
                }

                return value;
            },
            readableBoolean(value) {
                return value ? 'Oui' : 'Non';
            },
            maintenanceBadge(value) {
                if (value) {
                    return '<span class="inline-flex items-center rounded-full bg-amber-100 px-2.5 py-0.5 text-xs font-medium text-amber-900">En maintenance</span>';
                }

                return '<span class="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">En ligne</span>';
            },
            readablePrice(value) {
                return new Intl.NumberFormat('fr-BE', {
                    style: 'currency',
                    currency: 'EUR',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }).format(value)
            },
            readableSurface(value) {
                return new Intl.NumberFormat('fr-BE', {
                    style: 'decimal',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }).format(value) + ' m²'
            },
            image(value) {
                if(value !== null) {
                    return '<img src="' + value + '" />'
                }

                return "Pas d'image"
            },
            readableEnum(value, enums){
                return enums.labels[value];
            },
            handleSort(name) {
                this.$emit('sortBy', name);
            }
        },
        components: {
            Draggable: VueDraggableNext,
        }
    }
</script>
